<input type="date" class="form-control"
       [(ngModel)]="parsedValue"
       (ngModelChange)="update()">
